import { useMutation } from 'react-query'

import { createProduct } from '@features/products/query-api'

export const useCreateProduct = () => {
  const { mutate: create, isLoading: isProcessing, ...rest } = useMutation(createProduct)

  return {
    create,
    isProcessing,
    ...rest,
  }
}
